// extracted by mini-css-extract-plugin
export default {"add-btn":"add-btn___F4Uei","select-input":"select-input___GyF8O","tag":"tag___yTPpz","img-wrapper":"img-wrapper___Xpm70"};